'use strict';

require('./real-estate.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _clouds_real_estate = require('../../assets/clouds_real_estate.svg');

var _clouds_real_estate2 = _interopRequireDefault(_clouds_real_estate);

var _teams_icon = require('../../assets/teams_icon.svg');

var _teams_icon2 = _interopRequireDefault(_teams_icon);

var _audit_trail_icon = require('../../assets/audit_trail_icon.svg');

var _audit_trail_icon2 = _interopRequireDefault(_audit_trail_icon);

var _templates_icon = require('../../assets/templates_icon.svg');

var _templates_icon2 = _interopRequireDefault(_templates_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function RealEstate(p) {
    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations real-estate' },
        _react2['default'].createElement(TopArea, p),
        _react2['default'].createElement(
            'div',
            { className: 'seo-cloud-integrations__main', style: { backgroundColor: 'white' } },
            _react2['default'].createElement(PricingPlansCTA, { position: 'top' }),
            _react2['default'].createElement(Benefits, null),
            _react2['default'].createElement(HowItWorks, null),
            _react2['default'].createElement(Testimonial, null),
            _react2['default'].createElement(FAQ, null),
            _react2['default'].createElement(PricingPlansCTA, { position: 'bottom' })
        )
    );
}

function TopArea(p) {
    return _react2['default'].createElement(
        'div',
        { className: 'top row' },
        _react2['default'].createElement(
            'div',
            { className: 'top-content-container large-5 large-push-6 columns' },
            _react2['default'].createElement(
                'div',
                { className: 'title' },
                _react2['default'].createElement(
                    'h1',
                    null,
                    'HelloSign helps Agents & Brokers close deals'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'subtitle' },
                _react2['default'].createElement(
                    'h2',
                    { style: { fontWeight: 400, fontSize: 16, maxWidth: 600 } },
                    'Real estate agents and brokers love HelloSign because it\u2019s simple to use and helps get offer letters, counter offers, and listing agreements signed. There are enough headaches getting contracts signed, so our easy-to-use interface lets you track the status of your documents out for signature and notifies you once it\u2019s been signed. HelloSign\u2019s legally binding signatures have an average turnaround time of 44 minutes, so you can close deals faster.'
                )
            ),
            _react2['default'].createElement(SignUpButton, p)
        ),
        _react2['default'].createElement(
            'div',
            { className: 'clouds-container large-5 large-pull-4 columns', style: { float: 'left' } },
            _react2['default'].createElement('img', { src: _clouds_real_estate2['default'], alt: 'cloud left', style: { marginTop: 60, width: 550 } })
        )
    );
}

function SignUpButton(p) {
    return _react2['default'].createElement(_button2['default'], {
        buttonText: 'Get started',
        buttonColor: 'cerulean',
        buttonBorderColor: 'cerulean',
        buttonHoverColor: 'white',
        buttonHoverTextColor: 'cerulean',
        buttonLink: p.signUpUrl
    });
}

function PricingPlansCTA(p) {
    var position = p.position;
    var border = '2px solid #D7D7D7';
    var style = {
        borderTop: border,
        padding: '10px 0'
    };
    if (position === 'top') {
        style['borderBottom'] = border;
    }
    return _react2['default'].createElement(
        'div',
        { style: style },
        _react2['default'].createElement(
            'p',
            { style: { fontWeight: 600, lineSpacing: 0 } },
            'Free accounts include three documents a month. Upgrade for unlimited documents and more features. ',
            _react2['default'].createElement(
                'a',
                { href: '/info/pricing', target: '_blank', rel: 'noopener noreferrer',
                    style: { fontWeight: 500 } },
                'See Our Plans'
            ),
            '.'
        )
    );
}

function Benefits(p) {
    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations__benefits' },
        _react2['default'].createElement(
            'h2',
            null,
            'Benefits'
        ),
        _react2['default'].createElement(
            'div',
            { className: 'row' },
            _react2['default'].createElement(
                'section',
                { className: 'large-4 columns' },
                _react2['default'].createElement(
                    'div',
                    { className: 'benefits-image-container' },
                    _react2['default'].createElement('img', { src: _teams_icon2['default'], alt: 'teams icon' })
                ),
                _react2['default'].createElement(
                    'h3',
                    null,
                    'Add your whole office'
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'Admins can share templates, track the status of team members\u2019 open documents, and configure team settings and custom branding.'
                )
            ),
            _react2['default'].createElement(
                'section',
                { className: 'large-4 columns' },
                _react2['default'].createElement(
                    'div',
                    { className: 'benefits-image-container' },
                    _react2['default'].createElement('img', { src: _audit_trail_icon2['default'], alt: 'audit trail icon' })
                ),
                _react2['default'].createElement(
                    'h3',
                    null,
                    'Track signatures at every stage'
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'Stay up-to-date with notifications when your documents are viewed and signed. These activities are also logged in the document\u2019s legally binding audit trail.'
                )
            ),
            _react2['default'].createElement(
                'section',
                { className: 'large-4 columns end' },
                _react2['default'].createElement(
                    'div',
                    { className: 'benefits-image-container' },
                    _react2['default'].createElement('img', { src: _templates_icon2['default'], alt: 'templates icon' })
                ),
                _react2['default'].createElement(
                    'h3',
                    null,
                    'Templates for frequently used documents'
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'Auto-populate high volume documents with information using our templates and merge fields. Create the document once, reuse again and again.'
                )
            )
        )
    );
}

function HowItWorks(p) {
    var videoProps = {
        src: 'https://www.youtube.com/embed/sYpuROHdPbQ',
        frameBorder: 0,
        style: {
            width: '100%',
            maxWidth: 800,
            height: 430
        }
    };
    var paragraphStyle = {
        marginLeft: 20
    };
    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations__how-it-works' },
        _react2['default'].createElement(
            'h2',
            null,
            'How it Works'
        ),
        _react2['default'].createElement(
            'div',
            { className: 'row' },
            _react2['default'].createElement(
                'div',
                { className: 'screenshot-explanation large-4 large-push-8 columns' },
                _react2['default'].createElement(
                    'p',
                    { style: paragraphStyle },
                    'It\u2019s easy to send a document with HelloSign. To get started, figure out who has to sign your document: just you, just other people, or both you and others.'
                ),
                _react2['default'].createElement(
                    'p',
                    { style: paragraphStyle },
                    'You can upload the document from your hard drive, use a saved template, or bring in a document from one of your cloud storage accounts. Then, drag and drop the fields you want in the document.'
                ),
                _react2['default'].createElement(
                    'p',
                    { style: paragraphStyle },
                    'When the document is prepared, add your signers, set the order for signatures, and send! HelloSign\u2019s responsive design helps get the signatures you need on phones, tablets, or desktops.'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'dropbox-screenshot large-8 large-pull-4 columns' },
                _react2['default'].createElement('iframe', videoProps)
            )
        )
    );
}

function Testimonial(p) {
    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations__testimonial', style: { marginBottom: 70 } },
        _react2['default'].createElement(
            'p',
            { style: { fontSize: 14, fontWeight: 600 } },
            _react2['default'].createElement(
                'span',
                { style: { fontSize: 22, fontWeight: 300 } },
                '"Every one of our agents has a HelloSign Account."'
            ),
            '\xA0\xA0TOM TOGNOLI, Founder & CEO Intero Real Estate Services'
        )
    );
}

function FAQ(p) {
    var button = _react2['default'].createElement(_button2['default'], {
        buttonText: 'Visit our FAQ',
        buttonColor: 'cerulean',
        buttonBorderColor: 'cerulean',
        buttonHoverColor: 'white',
        buttonHoverTextColor: 'cerulean',
        buttonLink: 'https://faq.hellosign.com/hc/en-us/categories/200353538-HelloSign',
        openInNewWindow: true });
    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations__faq' },
        _react2['default'].createElement(
            'p',
            null,
            'Questions about this integration? We have answers.'
        ),
        button
    );
}

module.exports = RealEstate;


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/real-estate.jsx
 ** module id = 1628
 ** module chunks = 0
 **/